import type { SubstrateSearchSuggestionsResponse } from '../../data/schema/SubstrateSearchSuggestionsResponse';
import type { Suggestion } from '../../data/schema/SuggestionSet';

export default function applyBestMatchPositions(
    response: SubstrateSearchSuggestionsResponse,
    suggestions: Suggestion[]
): void {
    const bestMatchReferenceIds = response.LayoutHints?.BestMatchSuggestions?.map(
        suggestion => suggestion.ReferenceId
    );

    for (const suggestion of suggestions) {
        suggestion.BestMatchPosition = bestMatchReferenceIds
            ? bestMatchReferenceIds.indexOf(suggestion.ReferenceId)
            : -1;
    }
}
